<ng-container *ngIf="checkLoungeAvailability && contentLounge$ | async as contentLounge">
  <accordion class="accordion-container" *ngIf="extrasInfo">
    <accordion-group [panelClass]="'custom-class'" [isOpen]="expandExtras === extrasTypesEnum.LoungeAccess" closeOthers="true">
      <div accordion-heading class="heading-lounge">
        <img
          *ngIf="contentLounge?.loungeIcon"
          [src]="contentLounge.loungeIcon.url"
          [alt]="contentLounge.loungeIcon.title"
          class="circle-blue"
        />
        <span class="lounge-title font-weight-bold mt-1 ml-1">{{ contentLounge?.loungeTitle }}</span>
        <ng-content select="[header-extra-content]"></ng-content>
      </div>
      <form [formGroup]="loungeForm">
        <div>
          <accordion
            class="sub-accordion-container"
            *ngFor="let option of passengers[0]?.passengerExtras[extraProductsEnum.lounge]?.options; let optionIndex = index"
          >
            <app-accordion-custom>
              <div accordion-title class="sub-heading-lounge">
                <div class="circle-black">
                  <img *ngIf="contentLounge?.loungeIcon" [src]="contentLounge?.loungeIcon?.url" [alt]="contentLounge?.loungeIcon?.title" />
                </div>
                <span class="lounge-sub-title font-weight-bold mt-1 ml-2">{{ option?.displayText }}</span>
                <span class="mt-1 ml-2">
                  {{ contentLounge?.flightTo }}
                  {{ flightLegs[optionIndex]?.flightSegments[0].arrivalCity + ' ' }}
                  {{ contentLounge?.at }}
                  {{ flightLegs[optionIndex]?.departureTime + ',' }}
                  {{ flightLegs[optionIndex]?.departureDate | date : ddMMyyyy }}
                </span>
                <ng-content select="[extra-content]"></ng-content>
              </div>
              <div accordion-content class="accordion-content">
                <div class="lounge-content-title">{{ option?.displayText }}</div>
                <div class="lounge-description">
                  <i class="mdi mdi-airplane mr-1"></i>
                  <span class="location mr-2">
                    {{
                      flightLegs[optionIndex]?.flightSegments[0].departureCity +
                        ' (' +
                        flightLegs[optionIndex]?.flightSegments[0].departureAirportCode +
                        ') '
                    }}
                  </span>
                  <span class="font-weight-bold"> {{ flightLegs[optionIndex]?.departureTime }} </span>
                  <i class="mdi mdi-arrow-right"></i>
                  <span class="font-weight-bold mr-2">{{ flightLegs[optionIndex]?.arrivalTime }} </span>
                  <span class="mr-2">
                    {{
                      flightLegs[optionIndex]?.flightSegments[0].arrivalCity +
                        ' (' +
                        flightLegs[optionIndex]?.flightSegments[0].arrivalAirportCode +
                        ') ' +
                        ','
                    }}</span
                  >
                  <span> {{ flightLegs[optionIndex]?.departureDate | date : ddMMyyyy }} </span>
                </div>
                <div
                  [ngClass]="{
                    'passenger-description': passenger?.passengerExtras[extraProductsEnum.lounge]?.options?.length !== 0,
                  }"
                  *ngFor="let passenger of passengers; let passengerIndex = index"
                >
                  <div
                    class="passenger-description-container"
                    [ngClass]="{
                      selected: isLoungeSelected(passengerIndex, optionIndex)
                    }"
                    *ngIf="passenger?.passengerExtras[extraProductsEnum.lounge]?.options?.length !== 0"
                  >
                    <div class="passenger-data">
                      <div class="name">{{ passenger?.passengerDetails?.firstName + ' ' + passenger?.passengerDetails?.lastName }}</div>
                      <div class="dob">{{ passenger?.passengerDetails?.dateOfBirth | formatDate }}</div>
                    </div>

                    <!-- NOT Selected buttons -->
                    <div class="passenger-action">
                      <div *ngIf="!isLoungeSelected(passengerIndex, optionIndex) && loadingIndex !== passengerIndex" class="price">
                        + € {{ passenger?.passengerExtras[extraProductsEnum.lounge]?.options[0]?.displayPrice | formatDecimals : culture }}
                      </div>
                      <button
                        *ngIf="!isLoungeSelected(passengerIndex, optionIndex) && loadingIndex !== passengerIndex"
                        class="button"
                        [ngClass]="{
                          'disabled-button':
                            (loading || removing) && !isLoungeSelected(passengerIndex, optionIndex) && loadingIndex !== passengerIndex
                        }"
                        (click)="selectLounge(passenger?.passengerIdentifier, passengerIndex, optionIndex)"
                      >
                        {{ contentLounge?.add }}
                      </button>

                      <!-- Selecting state -->
                      <button
                        *ngIf="!isLoungeSelected(passengerIndex, optionIndex) && loading && loadingIndex === passengerIndex"
                        class="button"
                        (click)="selectLounge(passenger?.passengerIdentifier, passengerIndex, optionIndex)"
                      >
                        <div *ngIf="loading && loadingIndex === passengerIndex">
                          <div class="spinner-border spinner-border-sm mr-2 spinner-extras" role="status"></div>
                          {{ contentLounge?.selecting }}
                        </div>
                      </button>

                      <!-- Selected buttons -->
                      <div
                        *ngIf="isLoungeSelected(passengerIndex, optionIndex) && removingIndex !== passengerIndex"
                        class="selected-actions"
                      >
                        <div class="selected-lounge">
                          <img class="selected-icon" src="../../../../assets/icons/ic_check_circle.svg" alt="Check-Circle-Icon" />
                          {{ contentLounge?.selected }}
                        </div>
                        <button
                          class="remove-lounge"
                          (click)="removeLounge(passenger?.passengerIdentifier, passengerIndex, optionIndex, true)"
                        >
                          {{ contentLounge?.remove }}
                        </button>
                      </div>

                      <!-- Removing state -->
                      <div
                        *ngIf="isLoungeSelected(passengerIndex, optionIndex) && removing && removingIndex === passengerIndex"
                        class="selected-actions"
                      >
                        <div class="removing-lounge">
                          <div class="spinner-border spinner-border-sm mr-2 spinner-extras" role="status"></div>
                          {{ contentLounge?.removing }}
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </app-accordion-custom>
          </accordion>
        </div>
      </form>
      <div *ngIf="hasLoungeSelected" class="total-cost d-flex align-items-center">
        <p class="text-right align-items-center w-100 mr-4 mb-0">
          {{ contentLounge?.total | formatDecimals : culture }}:
          <span class="font-weight-bold">
            € {{ extrasInfo?.priceInfo?.pricePerProduct?.loungeAccessDisplayTotalPrice | formatDecimals : culture }}
          </span>
        </p>
      </div>
    </accordion-group>
  </accordion>
</ng-container>
